// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__1t8-T","Logo":"SideDrawer_Logo__FXbNr","Open":"SideDrawer_Open__26drA","Close":"SideDrawer_Close__mD7-2"};